import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/ui/button'

interface SectionSaveButtonProps {
  disabled: boolean
  /** Shows the spinner while this section is the one being saved. */
  saving: boolean
  onSave: () => void
  /** Overrides the default "Save" label. */
  label?: string
}

/** Small "Save" button of a section on the edit page. */
export function SectionSaveButton({ disabled, saving, onSave, label }: SectionSaveButtonProps) {
  const { t } = useTranslation()

  return (
    <Button size="sm" disabled={disabled} onClick={onSave}>
      {saving && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}
      {label ?? t('common.save')}
    </Button>
  )
}
